import { useParams } from "react-router";
import DocumentForm from "./DocumentForm";

export default function NewEquipmentDocument() {
  const { id } = useParams();
  return <DocumentForm ownerType={"EQUIPMENT"} ownerId={id} />;
}
